import { Select } from "PFComponents/select/select";
import CheckIcon from "PFIcons/round_check.svg";
import PropTypes from "prop-types";
import React, { useMemo, useState } from "react";

import css from "./select_groups.module.scss";

const SelectGroups = ({ group, groups, selectedGroups, onGroupSelected }) => {
  const [inputValue, setInputValue] = useState("");

  const options = useMemo(() => {
    const normalize = (text = "") => text.toLowerCase().replace(/ /g, "");
    const normalizedTerm = normalize(inputValue);

    return groups
      .filter((group) => normalize(group.text).indexOf(normalizedTerm) !== -1)
      .map((group) => {
        const isSelected = !!selectedGroups.find(({ id }) => id === group.id);
        const displayElement = (
          <div className={css.displayElement}>
            <span>{group.text}</span>
            {isSelected && <CheckIcon height={16} width={16} />}
          </div>
        );
        return {
          id: group.id,
          item: group,
          displayElement
        };
      });
  }, [groups, selectedGroups, inputValue]);

  const selectedIndex = options.findIndex((option) => option.id === group.id);

  const handleChange = (option) => onGroupSelected(option);
  const handleDropDownClose = () => setInputValue("");

  return (
    <Select
      className={css.select}
      inputInnerStyle={{ border: "none", fontWeight: 600 }}
      displayValues={group.text}
      options={options}
      handleChange={handleChange}
      handleInputChange={setInputValue}
      handleClose={handleDropDownClose}
      value={inputValue}
      selectedIndex={selectedIndex}
      closeOnChange
      controlledValue
      noPadding
    />
  );
};

SelectGroups.propTypes = {
  group: PropTypes.shape({
    id: PropTypes.number.isRequired,
    text: PropTypes.string.isRequired
  }).isRequired,
  groups: PropTypes.array.isRequired,
  selectedGroups: PropTypes.array.isRequired,
  onGroupSelected: PropTypes.func.isRequired
};
export default SelectGroups;
